import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  THEME_SCREEN_SHOT: {
    path: `${baseRoutes.userBaseRoutes}theme-screen-shot`,
  },
};

export default accessRoute;
